import { render, staticRenderFns } from "./electricityList.vue?vue&type=template&id=89904fb6&scoped=true&"
import script from "./electricityList.vue?vue&type=script&lang=js&"
export * from "./electricityList.vue?vue&type=script&lang=js&"
import style0 from "./electricityList.vue?vue&type=style&index=0&id=89904fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89904fb6",
  null
  
)

export default component.exports